module.exports = __webpack_public_path__ + "img/draw.cb897521.png";